"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressResolver__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_v1Factory",
                type: "address",
            },
            {
                internalType: "address",
                name: "_v2Factory",
                type: "address",
            },
            {
                internalType: "address",
                name: "_ecdsaModule",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "ecdsaOwnershipModule",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_eoa",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "_maxIndex",
                type: "uint8",
            },
        ],
        name: "resolveAddresses",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "accountAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "factoryAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "currentImplementation",
                        type: "address",
                    },
                    {
                        internalType: "string",
                        name: "currentVersion",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "factoryVersion",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "deploymentIndex",
                        type: "uint256",
                    },
                ],
                internalType: "struct IAddressResolver.SmartAccountResult[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_eoa",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "_maxIndex",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "_moduleAddress",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_moduleSetupData",
                type: "bytes",
            },
        ],
        name: "resolveAddressesFlexibleForV2",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "accountAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "factoryAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "currentImplementation",
                        type: "address",
                    },
                    {
                        internalType: "string",
                        name: "currentVersion",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "factoryVersion",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "deploymentIndex",
                        type: "uint256",
                    },
                ],
                internalType: "struct IAddressResolver.SmartAccountResult[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_eoa",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "_maxIndex",
                type: "uint8",
            },
        ],
        name: "resolveAddressesV1",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "accountAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "factoryAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "currentImplementation",
                        type: "address",
                    },
                    {
                        internalType: "string",
                        name: "currentVersion",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "factoryVersion",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "deploymentIndex",
                        type: "uint256",
                    },
                ],
                internalType: "struct IAddressResolver.SmartAccountResult[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "smartAccountFactoryV1",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "smartAccountFactoryV2",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class AddressResolver__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_v1Factory, _v2Factory, _ecdsaModule, overrides) {
        return super.deploy(_v1Factory, _v2Factory, _ecdsaModule, overrides || {});
    }
    getDeployTransaction(_v1Factory, _v2Factory, _ecdsaModule, overrides) {
        return super.getDeployTransaction(_v1Factory, _v2Factory, _ecdsaModule, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.AddressResolver__factory = AddressResolver__factory;
AddressResolver__factory.bytecode = _bytecode;
AddressResolver__factory.abi = _abi;
//# sourceMappingURL=AddressResolver__factory.js.map